import './ReportTypesTile.scss';

import { Button, Paper, Typography } from '@trackman/web-shared-components';
import { CREATE_PARAM, DefaultRoutes } from 'Routes';

import { ReactComponent as PlayerReportsGraphic } from 'svg/tileGraphics/PlayerReports.svg';
import { ReactComponent as SessionReportsGraphic } from 'svg/tileGraphics/SessionReports.svg';
import { ReactComponent as UmpireReportsGraphic } from 'svg/tileGraphics/UmpireReports.svg';
import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ReportSubType, ReportType } from 'types/CodegenDashboardTypes';

type Props = {
  report?: { reportType: ReportType; reportSubTypes: ReportSubType[] };
};

const ReportTypesTile = ({ report }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Paper className='report-types-tile'>
      {report ? (
        <>
          <div className='graphic-container'>
            {report.reportType === 'PlayerReport' && <PlayerReportsGraphic />}
            {report.reportType === 'PracticeReport' && <PlayerReportsGraphic />}
            {report.reportType === 'SessionReviewReport' && <SessionReportsGraphic />}
            {report.reportType === 'UmpireReport' && <UmpireReportsGraphic />}
          </div>
          <div className='content-container'>
            <div className='content-title-row'>
              <Typography variant='body bold' component='div'>
                {report.reportType && t(report.reportType)}
              </Typography>
              <Typography variant='label' component='div' color='#414141'>
                {report.reportSubTypes.length + ' ' + t('available')}
              </Typography>
            </div>
            <Typography variant='label' color='#A0A0A0' component='div'>
              {t(report.reportType + 'TileDescription')}
            </Typography>
          </div>
          <div className='buttons'>
            {report.reportSubTypes.map((subtype) => {
              const route = DefaultRoutes[report.reportType][subtype];
              return (
                route && (
                  <Button
                    key={subtype}
                    data-cy={`btn-${report.reportType}-${subtype}`}
                    intent='default'
                    href={route}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(route + '/' + CREATE_PARAM, { viewTransition: true });
                    }}
                  >
                    {t(subtype)}
                  </Button>
                )
              );
            })}
          </div>
        </>
      ) : (
        <Skeleton height={280} />
      )}
    </Paper>
  );
};

export default ReportTypesTile;
